import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { services } from './Services';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';

const useStyles = makeStyles(() => ({
  root: {
    padding: '2rem 0',
    width: '100%',
  },
}));

const MobileMenu = ({service}) => {
  const classes = useStyles();
  const history = useHistory();
  const options = services.map(o => ({ value: o.value, label: o.name }));
  const selectedOption = options.filter(o => o.value === service.value);

  const onChange = e => {
    history.push({pathname: `/profile/${e.value}`, state: { service: e.value }});
  };

  return (
    <div className={classes.root}>
      <Select options={options} value={selectedOption} onChange={onChange} />
    </div>
  );
};

MobileMenu.propTypes = {
  service: PropTypes.object.isRequired,
};

export default MobileMenu;
